import { defineMessages } from 'react-intl';

const messages = defineMessages({
  heading: {
    id: 'filter.heading',
    defaultMessage: 'Filter',
    description: 'Heading for filter',
  },
});

export default messages;
